import React, { useEffect, useState } from "react";
import {
  Typography,
  Modal,
  Button,
  TextField,
  Box,
  Stack,
  Select,
  MenuItem,
  Snackbar,
  FormLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useAxios from "../../utils/useAxios";
import { useDispatch } from "react-redux";
import { fetchAllDashboardUsers } from "../Reducers/dashboardUserReducer";

export default function AdminAddEmployeeModal({ companies, teams }) {
  /*
        adminEditEmployeeModal returns a button that will open a modal with the device details
        when clicked. The modal contain pre-populated fields with the device details. When
        the fields are changed, a save button will appear. When the save button is clicked,
        the device details will be updated in the database.

        This component exclusively uses MUI v5 components.
    */
  const api = useAxios();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(
    "Employee Created Successfully"
  );
  const handleSnackbarOpen = () => setSnackbarOpen(true);
  const handleSnackbarClose = () => setSnackbarOpen(false);
  const action = (
    <React.Fragment>
      <Button color="primary" size="small" onClick={handleSnackbarClose}>
        Close
      </Button>
    </React.Fragment>
  );

  const roles = [
    { id: 1, user_type: "Team Member" },
    { id: 2, user_type: "Company Admin" },
    { id: 3, user_type: "Super Admin" },
  ];

  const [inputEmail, setInputEmail] = useState("");
  const [inputFirstName, setInputFirstName] = useState("");
  const [inputLastName, setInputLastName] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedTeam, setSelectedTeam] = useState();
  //
  const [selectedRole, setSelectedRole] = useState("");
  const refreshUsers = () => {
    dispatch(fetchAllDashboardUsers(api));
  };

  const handleSave = () => {
    console.log("poot");
    api
      .post(`/dashboard_user/create/`, {
        email: inputEmail,
        first_name: inputFirstName,
        last_name: inputLastName,
        company: companies.find(
          (company) => company.company_name === selectedCompany
        ).id,
        user_type: roles.find((role) => role.user_type === selectedRole).id,
        team: selectedTeam,
        // Right now we need a placeholder for username even though it is not used
        username: inputEmail,
      })
      .then((res) => {
        if (res.status === 201) {
          console.log("User Created Successfully");
          setSnackbarMessage("User Created Successfully");
          handleSnackbarOpen();
          handleClose();
          refreshUsers();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackbarMessage("User Creation Failed: " + err.message);
        handleSnackbarOpen();
        handleClose();
      });
  };

  //   Whenever selectedCompany changes, update the teamList to only include teams from the selected company
  const [teamList, setTeamList] = useState([]);
  useEffect(() => {
    if (selectedCompany) {
      setTeamList(
        teams.filter(
          (team) =>
            team.company ===
            companies.find(
              (company) => company.company_name === selectedCompany
            ).id
        )
      );
    }
  }, [selectedCompany]);

  return (
    <>
      <Snackbar
        // position snackbar absolute to the top of the screen and centered
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        action={action}
      />

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <CloseIcon
            sx={{ position: "absolute", top: 10, left: 10 }}
            onClick={() => {
              handleClose();
            }}
          />
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h4" mb={2}>
              New User
            </Typography>
            <TextField
              id="outlined-basic"
              label="Email"
              variant="outlined"
              fullWidth
              mb={2}
              value={inputEmail}
              onChange={(e) => setInputEmail(e.target.value)}
            />
            <TextField
              id="outlined-basic"
              label="First Name"
              variant="outlined"
              fullWidth
              mb={2}
              value={inputFirstName}
              onChange={(e) => setInputFirstName(e.target.value)}
            />
            <TextField
              id="outlined-basic"
              label="Last Name"
              variant="outlined"
              fullWidth
              mb={2}
              value={inputLastName}
              onChange={(e) => setInputLastName(e.target.value)}
            />
            <FormLabel component="legend">Company</FormLabel>
            <Select
              labelId="select-user-company"
              id="select-user-company"
              label="Company"
              fullWidth
              mb={2}
              value={selectedCompany}
              onChange={(e) => setSelectedCompany(e.target.value)}
            >
              {companies.map((company) => (
                <MenuItem key={company.id} value={company.company_name}>
                  {company.company_name}
                </MenuItem>
              ))}
            </Select>
            <FormLabel component="legend">Team</FormLabel>
            <Select
              labelId="select-user-team"
              id="select-user-team"
              label="Team"
              fullWidth
              mb={2}
              value={selectedTeam}
              onChange={(e) => setSelectedTeam(e.target.value)}
            >
              {teamList.map((team) => (
                <MenuItem key={team.id} value={team.id}>
                  {team.team_name}
                </MenuItem>
              ))}
            </Select>
            {/* label */}
            <FormLabel component="legend">User Type</FormLabel>
            <Select
              labelId="select-user-type"
              id="select-user-type"
              label="Role"
              fullWidth
              mb={2}
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              {roles.map((role) => (
                <MenuItem key={role.id} value={role.user_type}>
                  {role.user_type}
                </MenuItem>
              ))}
            </Select>

            <Button
              onClick={() => {
                handleSave();
              }}
              sx={{ color: "white" }}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Button variant="contained" onClick={handleOpen} sx={{ color: "white" }}>
        Add Employee
      </Button>
    </>
  );
}
